/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import * as constants from "constants/constants";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";

const mapStoreToProps = (stores, ownProps) => ({
  icon: ownProps.icon,
  clickHandler: ownProps.clickHandler,
  ariaLabel: ownProps.title,
  tooltipString: ownProps.title,
  tooltipPlacement: constants.TOOLTIP_TOP_PLACEMENT,
  tooltipDelay: constants.TOOLTIP_DELAY
});
const ExternalComponentContainer = inject(mapStoreToProps)(ButtonWrapper);

export { ExternalComponentContainer };
